export default __webpack_public_path__ + "static/media/4.17bb67f3.webp";